import { Edit as EditIcon, CameraAlt as CameraIcon } from "@mui/icons-material";
import { Avatar, Box, Typography, IconButton } from "@mui/material";
import { colorTokens } from "theme/colorTokens";

interface PracticeLogoHeaderProps {
  readonly profilePicture?: string;
  readonly practiceName: string;
  readonly onUpdateLogo?: () => void;
  readonly onUpdateName?: () => void;
}

function PracticeLogoHeader({
  profilePicture,
  practiceName,
  onUpdateLogo,
  onUpdateName,
}: PracticeLogoHeaderProps) {
  return (
    <Box className="flex flex-col items-center space-y-4">
      <Box className="relative">
        <Avatar
          src={profilePicture}
          alt="Practice Logo"
          sx={{
            width: 120,
            height: 120,
            fontSize: "2rem",
            backgroundColor: colorTokens.gray[200],
          }}
        >
          {practiceName?.charAt(0).toUpperCase() || "P"}
        </Avatar>
        {onUpdateLogo && (
          <IconButton
            onClick={onUpdateLogo}
            sx={{
              position: "absolute",
              bottom: 0,
              right: 0,
              backgroundColor: "white",
              boxShadow: 2,
              "&:hover": {
                backgroundColor: colorTokens.gray[100],
              },
            }}
            size="small"
          >
            <CameraIcon fontSize="small" color="primary" />
          </IconButton>
        )}
      </Box>

      <Box className="flex items-center gap-2">
        <Typography
          variant="h4"
          className="text-3xl font-semibold text-center text-gray-900"
        >
          {practiceName || "Practice"}
        </Typography>
        {onUpdateName && (
          <IconButton onClick={onUpdateName} size="small" color="primary">
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

export default PracticeLogoHeader;
